import { EoFormConfig } from '../../form/eo-form/eo-form.config';

export interface IEoFormDialogConfig {
  visible?: boolean;
  header?: string;
  formConfig?: EoFormConfig;
  formNoValidate?: boolean;
  dialogStyleClass?: string;
  footerStyleClass?: string;
  submitDisabled?: boolean;
  submitLabel?: string;
  submitIcon?: string;
  submitLoading?: boolean;
  submitVisible?: boolean;
  cancelDisabled?: boolean;
  cancelLoading?: boolean;
  cancelLabel?: string;
  cancelVisible?: boolean;
  cancelIcon?: string;
  onSearch?: (event: any) => void;
  onCancel?: (event: any) => void;
  onFormChange?: (event: any) => void;
}

export class EoFormDialogConfig implements IEoFormDialogConfig {
  visible = false;
  header = '';
  formConfig?: EoFormConfig;
  formNoValidate = false;
  dialogStyleClass = 'w-full md:w-6 m-2 md:m-0';
  footerStyleClass = 'flex justify-content-end gap-2 mt-2';
  submitDisabled = false;
  submitLabel = 'Αποθήκευση';
  submitIcon = 'pi pi-save';
  submitLoading = false;
  submitVisible = true;
  cancelDisabled = false;
  cancelLoading = false;
  cancelLabel = 'Άκυρο';
  cancelVisible = true;
  cancelIcon = '-';
  onSubmit?: (event: any) => void;
  onCancel?: () => void;
  onFormChange?: (event: any) => void;

  constructor(config?: IEoFormDialogConfig) {
    if (config) {
      Object.assign(this, config);
    }
  }
}
